import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IAPIResponse } from "../../interfaces/IAPIResponse";

export interface CreateMeetLinkParams {
    meeting_title?: string;
    duration_minutes?: number;
    start_date?: string;
    start_time?: string;
    end_date?: string;
    end_time?: string;
    is_recurring?: boolean;
    recurrence_frequency?: string;
    recurrence_count?: number;
    recurrence_interval?: number;
    timezone_str?: string;
}

export interface MeetLinkData {
    meet_link: string;
}

const initialState: IReduxState<MeetLinkData> = {
    data: {
        status: false,
        message: "",
        data: {
            meet_link: ""
        }
    },
    isLoading: false,
    error: null
} as IReduxState<MeetLinkData>;

export const CreateMeetLinkSlice = createSlice({
    name: "CreateMeetLinkSlice",
    initialState,
    reducers: {
        createMeetLink: (state, _action: PayloadAction<CreateMeetLinkParams>) => {
            state.isLoading = true;
            state.error = null;
        },
        successCreateMeetLink: (state, action: PayloadAction<IAPIResponse<MeetLinkData>>) => {
            state.isLoading = false;
            state.data = action.payload;
        },
        failureCreateMeetLink: (state, action: PayloadAction<any>) => {
            state.isLoading = false;
            state.error = action.payload;
        },
        resetCreateMeetLink: (state) => {
            state.isLoading = false;
            state.data = initialState.data;
            state.error = null;
        }
    },
});

export const {
    createMeetLink,
    successCreateMeetLink,
    failureCreateMeetLink,
    resetCreateMeetLink,
} = CreateMeetLinkSlice.actions;

export default CreateMeetLinkSlice.reducer;
